import React from "react";
import { useGetMyEffectsQuery } from "../api/respectCardsApi";
import CardRow from "./CardRow";
import "../styles/cards.css";

export interface MyEffectsListProps {
  /** Skip the fetch when the user isn't authenticated. */
  skip?: boolean;
}

/**
 * "Running effects" section body — the surface the `card_expiry_played`
 * notification ("See effects" → /cards#effects) finally lands on. Lists the
 * viewer's own live effects (my-effects v2) as CardRows. Renders nothing but a
 * short empty line when there are no active effects, so the section header can
 * stay mounted for the hash anchor.
 */
export default function MyEffectsList({ skip }: MyEffectsListProps) {
  const { data, isLoading, isError } = useGetMyEffectsQuery(undefined, { skip });

  if (isLoading) {
    return <p className="cards-deck-empty">Loading your effects…</p>;
  }
  if (isError) {
    return <p className="cards-deck-empty">Could not load your active effects.</p>;
  }

  const effects = data?.effects ?? [];
  if (effects.length === 0) {
    return (
      <p className="cards-deck-empty">
        No effects running right now. Play a card to start one.
      </p>
    );
  }

  return (
    <ul className="card-effects-list">
      {effects.map((effect, i) => (
        <CardRow key={`${effect.instanceId ?? effect.effectType}-${i}`} effect={effect} />
      ))}
    </ul>
  );
}
